import { ProgramLogsResponseModel, ProgramLogsTableInfoModel } from "../../app/data/documents/programLogsModels";

export default interface ProgramLogsState {
  requestStarted: boolean;
  requestSucceed: boolean;
  requestFailed: boolean;
  requestError: string;
  requestCreator: string;
  records: ProgramLogsResponseModel[];
  recordsRequest: PaginationModel | null;
  downloadCsv: boolean;
  tableInfo: ProgramLogsTableInfoModel;
};

export const initialProgramLogsState: ProgramLogsState = {
  requestStarted: false,
  requestSucceed: false,
  requestFailed: false,
  requestError: "",
  requestCreator: "",
  records: [],
  recordsRequest: null,
  downloadCsv: false,
  tableInfo: {title: "", description: "", sections: []}
};
export interface PaginationModel {
    page: number,
    last: number,
  };
  